import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { capitalize } from 'lodash';

import { AddOns } from 'models/addons';
import { Location } from 'models/locations';
import Quote from 'models/quote';
import Search from 'models/search';

import CouponCode from 'components/checkout/review-and-confirm/coupon-code';
import CheckoutSummaryLineItem from 'components/common/checkout-summary-line-item';

import BrandName from 'containers/common/brand-name';

import { ExperimentsConsumer } from 'providers/experiments-provider';

const propTypes = {
  addOns: PropTypes.oneOfType([
    PropTypes.instanceOf(AddOns),
    PropTypes.instanceOf(Map),
  ]),
  currentSearch: PropTypes.instanceOf(Search),
  isFullTransparency: PropTypes.bool,
  isCheckoutSurprise: PropTypes.bool,
  location: PropTypes.instanceOf(Location),
  quote: PropTypes.instanceOf(Quote).isRequired,
  total: PropTypes.number,
  userCreditAmount: PropTypes.number,
};

const defaultProps = {
  addOns: new AddOns(),
  currentSearch: new Search(),
  isFullTransparency: false,
  isCheckoutSurprise: false,
  location: new Location(),
  total: 0,
  userCreditAmount: 0,
};

export class CheckoutSummary extends Component {
  get shouldDisplayFees() {
    const { isFullTransparency, isCheckoutSurprise, quote } = this.props;

    return (!quote.isAirport && !quote.isMonthly && (isFullTransparency || isCheckoutSurprise));
  }

  renderAddOns() {
    const { addOns, location } = this.props;

    const renderableAddOns = [];

    addOns.forEach((selectedAddOns) => {
      if (!selectedAddOns.isEmpty()) {
        selectedAddOns.forEach((selectedAddOn) => {
          renderableAddOns.push(
            <CheckoutSummaryLineItem
              key={selectedAddOn.id}
              label={capitalize(selectedAddOn.name)}
              location={location}
              opacity="50"
              value={selectedAddOn.formattedPrice}
            />,
          );
        });
      }
    });

    return renderableAddOns;
  }

  renderFee(fee, location) {
    if (!fee) return null;

    const { currentSearch } = this.props;
    const { displayConfig } = fee;

    return (
      <CheckoutSummaryLineItem
        child={displayConfig.child ? displayConfig.child(currentSearch) : null}
        Icon={displayConfig.icon}
        key={fee.type}
        label={displayConfig.label}
        location={location}
        opacity="50"
        value={fee.price}
      />
    );
  }

  renderFees() {
    const { location, quote } = this.props;

    if (this.shouldDisplayFees) {
      return quote.fees.sortBy(fee => fee.displayConfig.priority)
        .map(fee => this.renderFee(fee, location));
    }

    return null;
  }

  renderUserCredit() {
    const { location, userCreditAmount } = this.props;

    if (userCreditAmount <= 0) return null;

    const label =
      (<Fragment>
        <BrandName /> Credits
      </Fragment>);

    return (
      <CheckoutSummaryLineItem
        label={label}
        location={location}
        value={userCreditAmount}
        valuePrefix="-"
      />
    );
  }

  render() {
    const { location, quote, total } = this.props;

    return (
      <Fragment>
        <CheckoutSummaryLineItem
          label="Base Price"
          location={location}
          opacity="50"
          value={this.shouldDisplayFees ? quote.basePrice : quote.price}
        />
        {this.renderAddOns()}
        {this.renderFees()}
        <div className="margin-top-sm-20 margin-bottom-sm-20 margin-top-xs-10 margin-bottom-xs-20">
          <CouponCode />
          {this.renderUserCredit()}
        </div>
        <CheckoutSummaryLineItem
          label="Your Order Total"
          value={total}
          location={location}
          isTotalRow
        />
      </Fragment>
    );
  }
}

CheckoutSummary.propTypes = propTypes;
CheckoutSummary.defaultProps = defaultProps;

const CheckoutSummaryWrapper = props => (
  <ExperimentsConsumer>
    <CheckoutSummary {...props} />
  </ExperimentsConsumer>
);

export default CheckoutSummaryWrapper;
